import { useEffect, useState } from 'react';
import { CheckCircle2, Clock, Loader2 } from 'lucide-react';
import VotingHeader from './VotingHeader';
import { getRootSurvey, getVoteStatus } from '../api/voting';

export default function ThankYou() {
  const [survey, setSurvey]       = useState(null);
  const [settings, setSettings]   = useState(null);
  const [paid, setPaid]           = useState(null); // null = checking, true = confirmed, false = pending

  const ref = new URLSearchParams(window.location.search).get('ref');

  useEffect(() => {
    getRootSurvey()
      .then((res) => {
        const s   = res?.data?.survey;
        const cfg = res?.data?.settings;
        setSurvey(s);
        setSettings(cfg);
        if (cfg) {
          const root = document.documentElement;
          if (cfg.primary_color)    root.style.setProperty('--color-primary',    cfg.primary_color);
          if (cfg.secondary_color)  root.style.setProperty('--color-secondary',  cfg.secondary_color);
          if (cfg.background_color) {
            root.style.setProperty('--color-background', cfg.background_color);
            document.body.style.backgroundColor = cfg.background_color;
          }
          if (cfg.text_color) root.style.setProperty('--color-text', cfg.text_color);
        }
        if (s?.surveyname) document.title = 'Thank You — ' + s.surveyname;
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!ref) { setPaid(false); return; }

    getVoteStatus(ref)
      .then((res) => setPaid(res?.data?.paid === true))
      .catch(() => setPaid(false));
  }, [ref]);

  const isChecking = paid === null;

  return (
    <div className="content-voting min-vh-100 d-flex flex-column">
      <div className="container-xl px-3 px-md-4 pt-3 pb-3 flex-grow-1">

        <VotingHeader survey={survey} settings={settings} />

        <div className="d-flex flex-column align-items-center justify-content-center py-5 text-center" style={{ minHeight: 320 }}>

          {isChecking ? (
            <Loader2 size={40} className="text-warning mb-3 spin" />
          ) : paid ? (
            <>
              <div
                className="rounded-circle d-inline-flex align-items-center justify-content-center mb-4"
                style={{ width: 80, height: 80, background: 'rgba(25,135,84,0.12)' }}
              >
                <CheckCircle2 size={44} className="text-success" />
              </div>
              <h2 className="font-display fw-bold mb-2">Payment received!</h2>
              <p className="text-muted mb-4" style={{ maxWidth: 380 }}>
                Your votes have been recorded. A confirmation email has been sent to you. Thank you for participating!
              </p>
            </>
          ) : (
            <>
              <div
                className="rounded-circle d-inline-flex align-items-center justify-content-center mb-4"
                style={{ width: 80, height: 80, background: 'hsl(38 88% 52% / 0.12)' }}
              >
                <Clock size={44} className="text-warning" />
              </div>
              <h2 className="font-display fw-bold mb-2">Thank you!</h2>
              <p className="text-muted mb-4" style={{ maxWidth: 380 }}>
                Your payment request has been recorded. A confirmation email will be sent to you as soon as payment is confirmed. Thank you for participating!
              </p>
            </>
          )}

          <a href="/" className="btn gold-chip fw-semibold px-4">
            Back to voting
          </a>

        </div>
      </div>

      <footer className="text-center py-3 small credits-text">
        Powered by <a href="https://etuzo.co.ke" className="credits-link">eTuzo</a>
      </footer>
    </div>
  );
}
